import AssessmentServiceApi from "../../services/assessment-api";

const searchUser = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.searchUserByEmailAndAccountNumber(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const sendRefundRequest = (userGuid) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.sendRefundRequest(userGuid)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { searchUser, sendRefundRequest };
